import React from "react";
import classes from "./style.module.css";

import CustomModal from "../../assets/components/ModalComonent";
import CustomButton from "../../assets/components/CustomButton";
import QuestionImg from "../../assets/images/icons/questionMarkIconFilled.png";

export default function PurchaseDialog({
  open,
  close,
  itemName,
  itemPrice,
  handleConirm,
}) {
  const hadleConfirmAndClose = () => {
    handleConirm();
    close();
  };

  const handleClose = () => {
    close();
  };

  const purchaseDialogContent = (
    <div className="w-100 text-center">
      <img
        src={QuestionImg}
        alt="question-vector"
        className={classes.alertBanner}
      />
      <h3 className={classes.alertTitle}>تایید خرید</h3>
      <p className={classes.smallTitle}>
        آیا از خرید "{itemName}" در ازای {itemPrice}سکه راه بهشت اطمینان دارید؟
      </p>
      <div className="w-100 mt-4 d-flex align-items-center">
        <CustomButton clickHandler={hadleConfirmAndClose} text={"بله"} />
        <CustomButton
          color={"secondary"}
          clickHandler={handleClose}
          shadow={true}
          styles={{
            marginRight: "16px",
          }}
          text={"خیر"}
        />
      </div>
    </div>
  );

  return (
    <CustomModal
      open={open}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={purchaseDialogContent}
    />
  );
}
